import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";

export const Navbar = () => {
  const { t } = useTranslation();
  const loc = useLocation();
  const onAdmin = loc.pathname.startsWith("/admin");
  return (
    <header className="glass-nav sticky top-0 z-40" data-testid="navbar">
      <nav className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
        <Link to="/" className="font-serif text-2xl tracking-tight text-[#2C2A29]" data-testid="brand-link">
          Stay<span className="text-[#C86D53]">TLV</span>
        </Link>
        <div className="flex items-center gap-6 sm:gap-8">
          <Link to="/listings" data-testid="nav-stays-link"
                className="text-sm text-[#595450] hover:text-[#C86D53] transition-colors hidden sm:inline">
            {t("nav.stays")}
          </Link>
          {!onAdmin && (
            <Link to="/admin/login" data-testid="nav-admin-link"
                  className="text-sm text-[#595450] hover:text-[#C86D53] transition-colors">
              {t("nav.admin")}
            </Link>
          )}
          <LanguageSwitcher />
        </div>
      </nav>
    </header>
  );
};
